import axios from 'axios';

const submitParcel = async (body) => {
    const url = `${process.env.REACT_APP_BACKEND_ENDPOINT}shipments`;
    const token = process.env.REACT_APP_PARCEL_POINT_API_KEY;
    
    try {
        const response = await axios.post(url, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
}

export default submitParcel;